import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "utilities/hookutils";

const useMutateAndInvalidate = <T>(
  mutationFn: (...args: T[]) => Promise<any>,
  queryKeys: string[]
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) => queryKeys.some((q) => query.queryKey.includes(q))
      });
    },
    retry: false
  });
};

const mySelectionCountQueryKey = "mySelectionCount";

export const useMySelectionCount = (mainArea: server.dto.MainAreas) => {
  return useApi(
    async () => window.CoreApi.MySelection.Count(mainArea),
    [mySelectionCountQueryKey]
  );
};

export const useClearMySelectionCount = () => {
  return useMutateAndInvalidate(
    async (mainArea: server.dto.MainAreas) =>
      window.CoreApi.MySelection.ClearAll(mainArea),
    [mySelectionCountQueryKey]
  );
};

export const useRemoveSelection = (mainArea: server.dto.MainAreas) => {
  return useMutateAndInvalidate(async (ids: number[]) => window.CoreApi.MySelection.Remove({ ids, mainArea }), [mySelectionCountQueryKey]);
};

export const useAddSelection = (mainArea: server.dto.MainAreas) => {
  return useMutateAndInvalidate(async (ids: number[]) => window.CoreApi.MySelection.Add({ ids, mainArea }), [mySelectionCountQueryKey]);
};